import { ExpertsSkillSet } from "@shared-interfaces/ExpertsSkillSet";
import { ProductModel } from '@shared-model/products/ProductModel';

export class ModuleConfig {
  readonly ProductTypeIdsQueueWithTopups: number[];
  readonly ProductTypeIdsCallback: number[];
  readonly ProductTypeIdsIvr: number[];
  readonly ProductTypeIdsIm: number[];
  readonly ProductTypeIdsImTopupBundle: number[];
  readonly ProductTypeIdsImTopupPayg: number[];
  readonly CallbackProductChoiceEnabled: boolean;
  readonly ProductTypeIdBestOfferIvr: number;
  readonly ProductTypeIdBestOfferIm: number;
  readonly ProductSortBestOffer: (a: ProductModel, b: ProductModel) => number = (a, b) => a.PricePerMinute?.Amount - b.PricePerMinute?.Amount; // Default to sort by just PPM lowest first
  readonly QueueWarningEnabled: boolean;
  readonly ExpertsSupported: boolean;
  readonly ExpertTariffsSupported: boolean = false;
  readonly OnlineChatSupported: boolean = false;
  readonly UrlCreateAccount: string = "/Create-Account/";
  readonly UrlManageCards: string = "/My-Account/ManageCards/";
  readonly UrlRegisterCardAndPay: string = "/My-Account/RegisterCardAndPay/";
  readonly UrlForgotPassword: string = "/ForgotPassword/";
  readonly UrlExpertProfilePagePrefix: string = "";
  readonly FormFieldUsernameName: string = "Email";
  readonly ExpertsSkillSet: ExpertsSkillSet = { ExpertSkillType: {}, ExpertSkillTypeName: {}, ExpertSkillTypeCssClass: {}, };
  readonly FormFieldUsernameCanOnlyBeEmail: boolean = true;
  readonly ManageCardsFunctionalitySupported: boolean = false;
  readonly GoogleAnalyticsFunctionalitySupported: boolean = false;

  constructor(props: Partial<ModuleConfig>) {
    Object.assign(this, props);
  }
}
